/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Calories_One_LinerInputs */

const en_exp_calories_one_liner = /** @type {(inputs: Exp_Calories_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An estimate of the energy you burned, resting metabolism included. Rides use power first, runs use speed and gradient — heart rate steps in when that's missing.`)
};

const de_exp_calories_one_liner = /** @type {(inputs: Exp_Calories_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Schätzung der Energie, die du verbrannt hast — Grundumsatz inklusive. Beim Radfahren zählt zuerst die Leistung, beim Laufen Tempo und Steigung. Fehlt das, springt die Herzfrequenz ein.`)
};

/**
* | output |
* | --- |
* | "An estimate of the energy you burned, resting metabolism included. Rides use power first, runs use speed and gradient — heart rate steps in when that's missing." |
*
* @param {Exp_Calories_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_calories_one_liner = /** @type {((inputs?: Exp_Calories_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Calories_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_calories_one_liner(inputs)
	return de_exp_calories_one_liner(inputs)
});